module.exports = __webpack_public_path__ + "img/11.3e413446.gif";